import { STAGE_ACCENT_COLORS } from 'src/components/actionCards/actionCardColors';

/**
 * ONE stage icon set (Iconify, mdi *-outline weight) shared by the sidebar, the Launchpad
 * "Needs you today" cards, the table-strip stage cards and the Reporting stage KPI cards.
 * Keys cover every item in TABLE_MENU_GROUPS (src/constants/tableMenuLabels.js) so the
 * sidebar and the breadcrumb registry can reuse them.
 */
export const STAGE_ICONS = {
    NEW: 'mdi:account-plus-outline',
    BOOKED: 'mdi:calendar-check-outline',
    ATTENDED: 'mdi:account-check-outline',
    STARTED: 'mdi:tooth-outline',
    NHS: 'mdi:hospital-box-outline',
    CA_PIPELINE: 'mdi:chart-timeline-variant',
    ALIGNER_APPROVE: 'mdi:check-circle-outline',
    ALL: 'mdi:format-list-bulleted',
    ARCHIVED: 'mdi:archive-outline',
    DUPLICATE: 'mdi:content-copy',
    SPAM: 'mdi:shield-alert-outline',
    NO_TASK: 'mdi:clipboard-text-off-outline',
    FTA: 'mdi:account-off-outline',
    COMPLETED: 'mdi:check-decagram-outline',
    CLOSED: 'mdi:lock-outline',
    ALL_PATIENTS: 'mdi:account-group-outline',
    ALL_PRACTICES: 'mdi:domain',
};

// Stage accent colours — re-exported from the single source (not duplicated).
export const STAGE_COLORS = STAGE_ACCENT_COLORS;
